import { c as _c } from "react/compiler-runtime";
import { RichTextBodyCopySimple } from "@/components/common/rich-text/rich-text-body-copy-simple.component";
export interface WizardStepHeaderProps<T = unknown> {
  label: string;
  description: T | null | undefined;
}

/**
 * Per-step heading and optional rich-text description, rendered in the left
 * column of the form wizard layout.
 */
export const WizardStepHeader = t0 => {
  const $ = _c(7);
  const {
    label,
    description
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <h2 className="typography-mobile-heading-h6 tablet:typography-desktop-heading-h6 text-text-primary">{label}</h2>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = description ? <RichTextBodyCopySimple richText={description} as="body-tablet" className="text-text-secondary" /> : null;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col gap-3 tablet:gap-6">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};